<div class="tooltip-container">
  <ion-icon [name]="icone[type]" [className]="type"></ion-icon>
  <span [class]="classes">{{ label }}</span>
</div>